// extracted by mini-css-extract-plugin
export var errorIcon = "_pq-1";
export var nameLogo = "_pq-0";